<template>
  <div class="tags-wrapper">
    <div v-for="(tag, index) in displayTags" :key="tag.id + index" class="tag-content">
      <router-link :to="`/learning/tags/${ tag.slug }`">
        <span class="text-darkBlack little-typography-atm">{{ tag.name || tag.slug }}</span>
      </router-link>
    </div>
    <div v-if="tags.length > 4 && !showCounterTags" class="tag-content" @click="counterClick">
      <div>
        <i class="pi pi-plus-circle"></i>
        <span class="text-darkBlack little-typography-atm">More</span>
      </div>
    </div>
    <div v-if="tags.length > 4 && showCounterTags && !showMoreTags" class="tag-content show-less" @click="showLess">
      <div>
        <i class="pi pi-minus-circle"></i>
        <span class="text-baseColor little-typography-atm">Less</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Tag } from "@tmi/types/entities";
import { computed, ref } from "vue";

const props = defineProps<{
  tagsList: Array<Tag>
}>();
const showCounterTags = ref( false );
const showMoreTags = ref( false );
const tags = ref<Tag[]>( props.tagsList ?? [] as Tag[] );
const sortedTags = computed( () => {
  return tags.value.sort( ( tagA: Tag, tagB: Tag ) => {
    return tagA.slug.localeCompare( tagB.slug );
  } );
} );
const displayTags = computed( () => {
  if ( showMoreTags.value ) {
    return sortedTags.value;
  }
  if ( showCounterTags.value ) {
    return sortedTags.value;
  }
  return [ ...sortedTags.value ].slice( 0, 4 );
} );

function counterClick() {
  showCounterTags.value = true;
}

function showLess() {
  showCounterTags.value = false;
}
</script>

<style lang="scss" scoped>
.tags-wrapper {
  .tag-content {
    cursor: pointer;
    display: inline-flex;
    padding: 4px 10px;
    border: 1px solid #F0F0F0;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 6px;

    &.show-less {
      border: 1px solid #4CA973;
    }

    svg {
      margin-right: 4px;
    }
  }
}
</style>
